// @flow
import { Provider } from "react-redux";
import { HelmetProvider } from "react-helmet-async";
import { Router } from "react-router";

import ThemeProvider from "../react-theme/ThemeProvider";
import ErrorBoundary from "../react/ErrorBoundary";

import type { ComponentType, Node } from "react";
import type { RouterHistory } from "react-router";
import type { Theme } from "../react-theme/types";
import type { ReduxStore } from "../redux/types";
import type { Props as FallbackProps } from "../react/ErrorBoundaryFallback";

type Props = {
  +store: ReduxStore,
  +routerHistory: RouterHistory,
  +contextPath: string,
  +theme?: Theme | Array<Theme>,
  +children: ?Node,
  +ErrorFallbackComponent?: ComponentType<FallbackProps>,
};

/**
 */
export const Init = ({
  store,
  routerHistory,
  contextPath,
  theme,
  children,
  ErrorFallbackComponent,
}: Props): Node => (
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <ErrorBoundary FallbackComponent={ErrorFallbackComponent}>
          <Router history={routerHistory} basename={contextPath}>
            {children}
          </Router>
        </ErrorBoundary>
      </HelmetProvider>
    </ThemeProvider>
  </Provider>
);
Init.displayName = "BI.Init";
